import React, { useEffect, useState, useRef, useCallback } from 'react'
import { Link, useSearchParams } from 'react-router-dom';
import { Input, Label, Button, Card, CardBody, Col, Row, Alert, Modal, ModalBody, ModalHeader, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import { useNavigate } from 'react-router-dom'
import { showToast } from '../../components/Toast';
import { endCall, getAllAgents, getPrompt, makeCall, sendCallOtp } from '../../helper/backend-methods';
import PhoneInput from 'react-phone-input-2'
import OtpInput from 'react-otp-input'
import 'react-phone-input-2/lib/style.css'
import phoneLogo from "../../assets/images/phone.png";
import { getCallStatus } from '../../helper/api-methods';
import chatAi from "../../assets/images/chatAI.png";
import waves from "../../assets/images/waves.png";
import Image from '../../components/Image'
import warningImg from "../../assets/images/warningImg.png"
import { useAppContext } from '../../context/AppContext';
import parsePhoneNumber from 'libphonenumber-js'
import { decompressFromEncodedURIComponent } from "lz-string";
import TrialAlert from '../../components/TrialAlert';
import { extractDynamicVariables } from '../../helper/dynamicVariables';

const normalizePhoneForInput = (value = "") => {
    return String(value).replace(/[^\d]/g, "");
};

const formatPhoneForApi = (value = "") => {
    const digits = normalizePhoneForInput(value);
    return digits ? `+${digits}` : "";
};

const formatPhoneForDisplay = (value = "") => {
    const digits = normalizePhoneForInput(value);
    return digits ? `+${digits}` : "";
};


const MakeCall = () => {
    const history = useNavigate();
    const [searchParams] = useSearchParams();
    const { markTaskDoneTour, activeTour, twilioPhone, isTrial } = useAppContext();
    const encoded = searchParams.get("data");

    // Refs
    const ws = useRef(null);
    const chatRef = useRef(null);
    const timerStarted = useRef(false);
    const timerInterval = useRef(null);
    const messagesRef = useRef([]);

    // State
    const [messages, setMessages] = useState([]);
    const [callSummary, setCallSummary] = useState("");
    const [statusBtn, setStatusBtn] = useState(false);
    const [callStatusDesc, setCallStatusDesc] = useState("");
    const [callStatus, setCallStatus] = useState("");
    const [callTimer, setCallTimer] = useState("00:00");
    const [timerRunning, setTimerRunning] = useState(false);
    const [secondsElapsed, setSecondsElapsed] = useState(0);
    const [sid, setSid] = useState("");
    const [currentTab, setCurrentTab] = useState(1);
    const [loading, setLoading] = useState(false);
    const [callErrorModal, setCallErrorModal] = useState(false);
    const [prompts, setPrompts] = useState([]);
    const [agents, setAgents] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [selectedAgent, setSelectedAgent] = useState({});
    const [errors, setErrors] = useState({});
    const [selectedPrompt, setSelectedPrompt] = useState({ _id: 0, title: "", prompt: "" });

    const [dynamicVariableModal, setDynamicVariableModal] = useState(false);
    const [dynamicFields, setDynamicFields] = useState([]);
    const [dynamicVariableValues, setDynamicVariableValues] = useState({});
    const [dynamicVariableErrors, setDynamicVariableErrors] = useState({});
    const [pendingCallData, setPendingCallData] = useState(null);

    const [otpModal, setOtpModal] = useState(false);
    const [pendingOtpCallData, setPendingOtpCallData] = useState(null);
    const [callOtp, setCallOtp] = useState("");
    const [otpError, setOtpError] = useState("");
    const [otpSending, setOtpSending] = useState(false);
    const [otpTimer, setOtpTimer] = useState(60);
    const [canResendOtp, setCanResendOtp] = useState(false);

    const steps = [
        { id: 1, label: "Choose an Agent", icon: <i className="ri-user-line" style={{ color: "#939393" }}></i>, iconActive: <i className="ri-user-line"></i> },
        { id: 2, label: "Enter Phone Number", icon: <i className="ri-phone-line" style={{ color: "#939393" }}></i>, iconActive: <i className="ri-phone-line"></i> },
        { id: 3, label: "Make Call", icon: <i className="ri-verified-badge-line" style={{ color: "#939393" }}></i>, iconActive: <i className="ri-verified-badge-line"></i> },
    ];

    // WebSocket connection
    useEffect(() => {
        if (!sid) return;

        ws.current = new WebSocket(`${process.env.REACT_APP_SOCKET_URL}/media-stream`);

        ws.current.onopen = () => {
            console.log("Connected to WebSocket server");
            ws.current.send(JSON.stringify({ event: "transcript", callSid: sid }));
        };

        ws.current.onmessage = (event) => {
            // console.log("Raw message received:", event.data);
            try {
                if (!timerStarted.current) {
                    startTimer();
                    timerStarted.current = true;
                }
                setCallStatusDesc("");
                setCallStatus("");
                setStatusBtn(false);
                const message = JSON.parse(event.data);
                console.log("message", message);
                // setMessages((prevMessages) => [...prevMessages, message]);
                setMessages(prev => {
                    const updated = [...prev, message];
                    messagesRef.current = updated;
                    return updated;
                });
                if (message.sender === "system") {
                    setCallSummary(message.callSummary);
                    const isInPromptTour = activeTour && activeTour.taskId === 3;

                    if (isInPromptTour) {
                        // Close any open driver.js instance first
                        const driverInstance = document.querySelector('.driver-popover');
                        if (driverInstance) {
                            // Find and trigger the close button
                            const closeBtn = driverInstance.querySelector('.driver-popover-close-btn');
                            if (closeBtn) {
                                closeBtn.click();
                            }
                        }

                        // Small delay to ensure driver.js is closed
                        setTimeout(() => {
                            markTaskDoneTour(3);
                        }, 100);
                    } else {
                        markTaskDoneTour(3, false);
                    }
                    resetTimer();
                }
            } catch (error) {
                console.error("Error parsing received message:", error);
            }
        };

        ws.current.onclose = () => console.log("Disconnected from WebSocket server");
        ws.current.onerror = (error) => console.error("WebSocket error:", error);

        return () => {
            if (ws.current) {
                ws.current.close();
            }
        };
    }, [sid]);

    // Auto-scroll chat
    useEffect(() => {
        chatRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    // Timer effect
    useEffect(() => {
        if (timerRunning) {
            const minutes = Math.floor(secondsElapsed / 60).toString().padStart(2, "0");
            const seconds = (secondsElapsed % 60).toString().padStart(2, "0");
            setCallTimer(`${minutes}:${seconds}`);
        }
    }, [secondsElapsed]);

    // OTP resend countdown
    useEffect(() => {
        let interval;
        if (otpModal && otpTimer > 0) {
            interval = setInterval(() => {
                setOtpTimer((prev) => prev - 1);
            }, 1000);
        } else if (otpTimer === 0) {
            setCanResendOtp(true);
        }

        return () => clearInterval(interval);
    }, [otpModal, otpTimer]);

    // Fetch agents on mount
    useEffect(() => {
        if (encoded) {
            try {
                const decompressedData = decompressFromEncodedURIComponent(encoded);
                const parsedData = decompressedData ? JSON.parse(decompressedData) : {};
                setPhoneNumber(normalizePhoneForInput(parsedData.to));
                setSelectedAgent(parsedData.agent || {});
                console.log("phone", parsedData.to);
                console.log("agent", parsedData.agent);

                if (!parsedData.to && !parsedData.agent) {
                    fetchAgents();
                } else {
                    nextStep(3, parsedData.to, parsedData.agent);
                }
            } catch (error) {
                console.error("Error parsing compressed data:", error);
                fetchAgents(); // Fallback to fetching agents
            }
        } else {
            fetchAgents();
        }
    }, [encoded]);

    const startTimer = () => {
        setTimerRunning(true);
        setSecondsElapsed(0);
        timerInterval.current = setInterval(() => {
            setSecondsElapsed((prev) => prev + 1);
        }, 1000);
    };

    const resetTimer = () => {
        clearInterval(timerInterval.current);
        setCallTimer("00:00");
        setSecondsElapsed(0);
        setTimerRunning(false);
        timerStarted.current = false;
    };

    const fetchAgents = useCallback(async () => {
        setLoading(true);
        setAgents([]);
        try {
            const data = await getAllAgents();
            if (data.data?.length) {
                setAgents(data.data || []);
                setSelectedAgent(data.data[0]);
            } else {
                const isInPromptTour = activeTour && activeTour.taskId === 3;
                if (isInPromptTour) {
                    // Close any open driver.js instance first
                    const driverInstance = document.querySelector('.driver-popover');
                    if (driverInstance) {
                        // Find and trigger the close button
                        const closeBtn = driverInstance.querySelector('.driver-popover-close-btn');
                        if (closeBtn) {
                            closeBtn.click();
                        }
                    }
                }
                history("/create-new-agent");
                showToast("error", "Request Failed", "Please create an agent first.");
            }
        } catch (err) {
            showToast("error", "Request Failed", err.message);
        } finally {
            setLoading(false);
        }
    }, [history]);

    const getPromptsHandler = useCallback(async (agent) => {
        setSelectedPrompt([]);
        try {
            const data = await getPrompt();
            if (data.data?.length) {
                setPrompts(data.data);
                const selectedItem = data.data.find((item) => item._id === agent.promptId);
                setSelectedPrompt(selectedItem || {});
            } else {
                history("/create-new-prompt");
                showToast("error", "Request Failed", "Please create a prompt first.");
            }
        } catch (err) {
            showToast("error", "Request Failed", err.message);
        }
    }, [history]);

    const handlePromptChange = useCallback((id) => {
        const selectedItem = prompts.find((item) => item._id === id);
        setSelectedPrompt(selectedItem || {});
    }, [prompts]);

    const handleAgentChange = useCallback((id) => {
        const selectedItem = agents.find((item) => item._id === id);
        setSelectedAgent(selectedItem || {});
    }, [agents]);

    const checkInitialCallStatus = useCallback(async (callSid) => {
        try {
            const data = await getCallStatus("/call/call-status", { sid: callSid });
            setCallSummary(getCallStatusMessage(data.status));
            const isInPromptTour = activeTour && activeTour.taskId === 3;

            if (isInPromptTour) {
                // Close any open driver.js instance first
                const driverInstance = document.querySelector('.driver-popover');
                if (driverInstance) {
                    // Find and trigger the close button
                    const closeBtn = driverInstance.querySelector('.driver-popover-close-btn');
                    if (closeBtn) {
                        closeBtn.click();
                    }
                }
            }

            //     // Small delay to ensure driver.js is closed
            //     setTimeout(() => {
            //         markTaskDoneTour(3);
            //     }, 100);
            // }
            // else {
            //     markTaskDoneTour(3, false);
            // }
        } catch (error) {
            console.log("error", error);
        }
    }, []);

    const startCall = useCallback(async ({ currentPhone, agentId, dynamicVariable = {}, otp }) => {
        try {
            setLoading(true);

            const formData = {
                ...(twilioPhone && { twilioPhone: twilioPhone }),
                to: currentPhone,
                agentId: agentId,
                dynamicVariables: dynamicVariable,
                ...(otp ? { otp: Number(otp) } : {}),
            };

            const data = await makeCall(formData);

            if (data.data?.sid) {
                setCurrentTab(3);
                setSid(data.data.sid);
                setOtpModal(false);

                setTimeout(() => {
                    setStatusBtn(true);
                }, 20000);

                setTimeout(() => {
                    if (messagesRef.current.length === 0) {
                        checkInitialCallStatus(data.data.sid);
                    }
                }, 60000);

                return { success: true };
            }

            if (data.data.trialEnded) {
                const isInPromptTour = activeTour && activeTour.taskId === 3;

                if (isInPromptTour) {
                    const driverInstance = document.querySelector('.driver-popover');
                    if (driverInstance) {
                        const closeBtn = driverInstance.querySelector('.driver-popover-close-btn');
                        if (closeBtn) {
                            closeBtn.click();
                        }
                    }
                }

                setOtpModal(false);
                setCallErrorModal(true);
                return { success: false, trialEnded: true };
            }

            const message = data.data?.message || "Your call could not be initiated.";
            if (!otp) {
                showToast("error", "Call Failed", message);
            }
            return { success: false, message };
        } catch (error) {
            showToast("error", "Call Failed", "Your call could not be initiated.");
            return { success: false };
        } finally {
            setLoading(false);
        }
    }, [twilioPhone, activeTour, checkInitialCallStatus]);

    const sendTrialOtp = useCallback(async (phone) => {
        setOtpSending(true);
        setOtpError("");
        try {
            const data = await sendCallOtp({ to: phone });
            if (data.data?.success === false) {
                setOtpError(data.data.message || "Unable to send OTP");
                showToast("error", "OTP Failed", data.data.message || "Unable to send OTP");
            } else {
                showToast("success", "OTP Sent", "Please enter the verification code sent to your phone.");
                setOtpTimer(60);
                setCanResendOtp(false);
            }
        } catch (error) {
            setOtpError("Unable to send OTP. Please try again.");
            showToast("error", "OTP Failed", "Unable to send OTP. Please try again.");
        } finally {
            setOtpSending(false);
        }
    }, []);

    const openOtpModal = useCallback((callData) => {
        setPendingOtpCallData(callData);
        setCallOtp("");
        setOtpError("");
        setOtpTimer(60);
        setCanResendOtp(false);
        setOtpModal(true);
        sendTrialOtp(callData.currentPhone);
    }, [sendTrialOtp]);

    const proceedToCall = useCallback((callData) => {
        if (isTrial) {
            openOtpModal(callData);
        } else {
            startCall(callData);
        }
    }, [isTrial, openOtpModal, startCall]);

    const handleResendOtp = useCallback(() => {
        if (!pendingOtpCallData) return;
        setCallOtp("");
        sendTrialOtp(pendingOtpCallData.currentPhone);
    }, [pendingOtpCallData, sendTrialOtp]);

    const handleVerifyAndCall = useCallback(async () => {
        if (!callOtp || callOtp.length < 6) {
            setOtpError("Please enter the 6-digit OTP sent to your phone");
            return;
        }

        setOtpError("");
        const result = await startCall({ ...pendingOtpCallData, otp: callOtp });

        if (!result?.success && !result?.trialEnded) {
            setOtpError(result?.message || "Unable to verify OTP. Please try again.");
        }
    }, [callOtp, pendingOtpCallData, startCall]);

    const nextStep = useCallback(async (step, phone = "", agent = {}) => {
        if (step === 2) {
            setCurrentTab(2);
            return;
        }

        if (step === 3) {
            const error = { phoneNumber: "" };
            const currentPhone = formatPhoneForApi(phone || phoneNumber);

            if (!currentPhone || currentPhone.length < 10) {
                error.phoneNumber = 'Please provide a valid phone number to proceed';
                setErrors(error);
                return;
            }
            setErrors({});

            // try {
            //     setLoading(true);
            //     let agentId;
            //     if (agent && agent.agentId) {
            //         agentId = agent.agentId;
            //     } else if (selectedAgent && selectedAgent.agentId) {
            //         agentId = selectedAgent.agentId;
            //     } else {
            //         agentId = null;
            //     }
            //     if (!agentId) {
            //         showToast("error", "Agent Missing", "This call cannot be redialed because the agent is missing.");
            //         setLoading(false);
            //         return;
            //     }
            //     const formData = {
            //         ...(twilioPhone && { "twilioPhone": twilioPhone }),
            //         "to": currentPhone,
            //         "agentId": agentId,
            //         // "agentId": selectedAgent.agentId,
            //     };
            //     const data = await makeCall(formData);
            //     if (data.data?.sid) {
            //         setCurrentTab(3);
            //         setSid(data.data.sid);
            //         setTimeout(() => {
            //             setStatusBtn(true);
            //         }, 20000);
            //         setTimeout(() => {
            //             if (messagesRef.current.length === 0) {
            //                 checkInitialCallStatus(data.data.sid);
            //             }
            //         }, 60000);
            //     }
            //     setLoading(false);
            //     if (data.data.trialEnded) {
            //         const isInPromptTour = activeTour && activeTour.taskId === 3;
            //         if (isInPromptTour) {
            //             // Close any open driver.js instance first
            //             const driverInstance = document.querySelector('.driver-popover');
            //             if (driverInstance) {
            //                 // Find and trigger the close button
            //                 const closeBtn = driverInstance.querySelector('.driver-popover-close-btn');
            //                 if (closeBtn) {
            //                     closeBtn.click();
            //                 }
            //             }
            //         }
            //         setCallErrorModal(true)
            //     }
            // } catch (error) {
            //     showToast("error", "Call Failed", "Your call could not be initiated.");
            //     setLoading(false);
            // }
            let agentId;

            if (agent && agent.agentId) {
                agentId = agent.agentId;
            } else if (selectedAgent && selectedAgent.agentId) {
                agentId = selectedAgent.agentId;
            } else {
                agentId = null;
            }

            if (!agentId) {
                showToast("error", "Agent Missing", "This call cannot be redialed because the agent is missing.");
                return;
            }

            const currentAgent = agent && agent.agentId ? agent : selectedAgent;
            const fields = extractDynamicVariables(
                `${currentAgent?.prompt || ""} ${currentAgent?.firstMessage || ""}`
            );

            const callData = {
                currentPhone,
                agentId,
            };

            if (fields.length > 0) {
                openDynamicVariableModal(fields, callData);
                return;
            }

            proceedToCall({
                ...callData,
                dynamicVariable: {},
            });
        }
    }, [phoneNumber, selectedAgent, messages, proceedToCall, dynamicVariableValues]);

    const getCallStatusMessage = (status) => {
        const statusMessages = {
            "queued": "Your call is in queue and will be initiated shortly.",
            "initiated": "Call has been initiated and is connecting to the recipient.",
            "ringing": "The recipient's phone is ringing. Please wait for them to answer.",
            "in-progress": "Our agent is currently attempting to contact the provided phone number. Please ensure availability so we can assist you promptly.",
            "completed": "Call has been successfully completed.",
            "busy": "Apologies, the person you're trying to reach is currently unavailable or occupied.",
            "no-answer": "The recipient did not answer the call. Please try again later.",
            "canceled": "The call was canceled before it could be completed.",
            "failed": "The call failed due to technical issues. Please try again."
        };

        return statusMessages[status] || "Unknown call status. Please check the call details.";
    };

    const checkCallStatus = useCallback(async () => {
        setCallStatusDesc("");
        setCallStatus("");
        setLoading(true);
        try {
            const data = await getCallStatus("/call/call-status", { sid: sid });
            setCallStatusDesc(getCallStatusMessage(data.status));
            setCallStatus(data.status);
        } catch (error) {
            console.log("error", error);
            setCallStatusDesc("Unable to fetch call status. Please try again.");
        } finally {
            setLoading(false);
        }
    }, [sid]);

    const endCallHandler = useCallback(async () => {
        try {
            const data = await endCall(sid);
            if (data.data.status === "completed") {
                resetCall();
            } else {
                showToast("error", "Request Failed", "Call can not be ended.");
            }
        } catch (err) {
            showToast("error", "Request Failed", err.message);
        }
    }, [sid]);

    const resetCall = useCallback(() => {
        setCurrentTab(1);
        setPhoneNumber("");
        setCallStatus("");
        setCallStatusDesc("");
        setStatusBtn(false);
        setSid("");
        setMessages([]);
        setCallSummary("");
        resetTimer();
    }, []);

    const openDynamicVariableModal = (fields, callData) => {
        const nextValues = {};

        fields.forEach((field) => {
            nextValues[field] = dynamicVariableValues[field] || "";
        });

        setDynamicFields(fields);
        setDynamicVariableValues(nextValues);
        setDynamicVariableErrors({});
        setPendingCallData(callData);
        setDynamicVariableModal(true);
    };

    const handleDynamicVariableChange = (field, value) => {
        setDynamicVariableValues((prev) => ({
            ...prev,
            [field]: value,
        }));

        setDynamicVariableErrors((prev) => ({
            ...prev,
            [field]: "",
        }));
    };

    const validateDynamicVariables = () => {
        const nextErrors = {};
        let hasError = false;

        dynamicFields.forEach((field) => {
            if (!dynamicVariableValues[field] || !dynamicVariableValues[field].trim()) {
                nextErrors[field] = "This field is required";
                hasError = true;
            }
        });

        setDynamicVariableErrors(nextErrors);
        return !hasError;
    };

    const handleDynamicVariableSubmit = () => {
        if (!validateDynamicVariables()) {
            return;
        }

        setDynamicVariableModal(false);

        proceedToCall({
            ...pendingCallData,
            dynamicVariable: dynamicVariableValues,
        });
    };

    const renderStepContent = () => {
        switch (currentTab) {
            case 1:
                return (
                    <>
                        <h4 className='mb-4'>Choose Agent</h4>
                        <Row>
                            <Col md={12} className='mb-4'>
                                <Label htmlFor="agent" className="text-left text-black font-bold"> Agent </Label>
                                <Input id="agent" className='custom-select rounded border-0 py-2' type="select" value={selectedAgent?._id || ""} onChange={(e) => handleAgentChange(e.target.value)} >
                                    {agents.map((item) => (
                                        <option key={item._id} value={item._id}>{item.name}</option>
                                    ))}
                                </Input>
                            </Col>
                            <Col md={12} className='mb-4'>
                                <Label htmlFor="prompt" className="text-left text-black font-bold"> First Message </Label>
                                <Input id="prompt" disabled={true} className='custom-select rounded border-0 py-2' type="text" value={selectedAgent?.firstMessage || ""} />
                            </Col>
                            <Col md={12} className='mb-4'>
                                <Label htmlFor="purpose" className="text-left text-black font-bold"> Agent Goal </Label>
                                <input disabled={true} type="text" id="purpose" className={`form-control custom-input`} value={selectedAgent?.purpose || ""} />
                            </Col>
                            <Col md={12} className='mb-4'>
                                <textarea disabled={true} value={selectedAgent?.prompt || ""} className='fs-16 rounded p-2 custom-textarea' ></textarea>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} className='text-right'>
                                <Button disabled={loading} onClick={() => nextStep(2)} className="px-4 py-2 rounded linear-gradient-btn">Next</Button>
                            </Col>
                        </Row>
                    </>
                );
            case 2:
                return (
                    <>
                        <h4 className='mb-4'>Enter Phone Number</h4>
                        <Row className='mb-4'>
                            <PhoneInput
                                country={twilioPhone ? parsePhoneNumber(twilioPhone).country.toLowerCase() : "us"}
                                autoFormat={true}
                                value={phoneNumber}
                                onChange={setPhoneNumber}
                                countryCodeEditable={false}
                                inputStyle={{ width: "100%", border: '1px solid #f1f1f1', WebkitTextFillColor: '#939393', WebkitBoxShadow: '0 0 0px 1000px #f1f1f1 inset', transition: 'background-color 5000s ease-in-out 0s' }}
                                dropdownStyle={{ border: "none !important", outline: "none" }}
                            />
                            {errors.phoneNumber && <div className="invalid-feedback">{errors.phoneNumber}</div>}
                        </Row>
                        <Row>
                            <Col md={12} className='text-right'>
                                <Button onClick={() => setCurrentTab(1)} className="px-4 py-2 rounded me-2 linear-gradient-btn">Back</Button>
                                <Button disabled={loading} onClick={() => nextStep(3)} className="px-4 py-2 rounded linear-gradient-btn">{loading ? (<> <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Please Wait </>) : "Next"}</Button>
                            </Col>
                        </Row>
                    </>
                );
            case 3:
                return (
                    <>
                        <h3 className="fs-34 fw-500 mt-2 mb-4 text-dark text-center">We will call you momentarily</h3>
                        <div className='d-flex flex-column justify-content-center align-items-center ongoing-call w-50 ms-auto me-auto'>
                            <img src={phoneLogo} alt="" className="mb-3" />
                            <p className='text-white'>{formatPhoneForDisplay(phoneNumber)}</p>
                        </div>
                        {statusBtn && (
                            <div className="mt-4 text-center">
                                <Button disabled={loading} onClick={checkCallStatus} className="btn-lg w-50 call-status-btn">
                                    {loading ? "Please Wait" : "Didn't Receive The Call (Check Status)"}
                                </Button>
                            </div>
                        )}
                        {callStatusDesc && (
                            <Alert color="warning" className='mt-4 text-center w-50 ms-auto me-auto'>{callStatusDesc}</Alert>
                        )}
                        {(callStatus === "busy" || callStatus === "no-answer") && (
                            <div className="mt-4 text-center">
                                <Button disabled={loading} onClick={resetCall} className="btn-lg w-50 call-status-btn">Make Another Call</Button>
                            </div>
                        )}
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <div className="content-page">
            <div className="content">
                <div className="container-fluid" id='make-call-form' style={{ paddingBottom: "160px" }}>
                    <Row>
                        <Col md={12}>
                            {!messages.length && !callSummary ? (
                                <>
                                    <Row className="my-3 align-items-center">
                                        <Col md={12}>
                                            <h4>Make a Call</h4>
                                            <p className='text-muted fs-12'>Make a new Call</p>
                                        </Col>
                                    </Row>

                                    {isTrial ? <TrialAlert /> : null}
                                    <Row className="card-row">
                                        <Col md={12}>
                                            <Card className='bg-white rounded-2'>
                                                <CardBody>
                                                    <div className="d-flex justify-content-center mb-5">
                                                        {steps.map((step, index) => (
                                                            <React.Fragment key={step.id}>
                                                                <div className="d-flex flex-column align-items-center justify-content-center text-center">
                                                                    <div
                                                                        className={`d-flex justify-content-center align-items-center text-white fs-16 steps-card`}
                                                                        style={{
                                                                            border: index === currentTab - 1 ? "none" : "1px solid #e6e6e6",
                                                                            background: index === currentTab - 1 ? "var(--wr-gradient-brand)" : "#fff"
                                                                        }}
                                                                    >
                                                                        {index === currentTab - 1 ? step.iconActive : step.icon}
                                                                    </div>
                                                                    <div className="">
                                                                        <h6 className={`mb-0 mt-2 ${index === currentTab - 1 ? "text-black" : "text-muted"}`}>{step.label}</h6>
                                                                    </div>
                                                                </div>
                                                                {index < 2 && <span className="steps-separator"></span>}
                                                            </React.Fragment>
                                                        ))}
                                                    </div>
                                                    {renderStepContent()}
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                </>
                            ) : (
                                <>
                                    {!callSummary ? (
                                        <>
                                            <div className="call-container">
                                                <div className='d-flex flex-column align-items-center'>
                                                    <div className="call-timer">
                                                        <div className="wave-container">
                                                            <img src={waves} alt="Waves" className="wave-image" />
                                                        </div>
                                                        <div className="timer-text">{callTimer}</div>
                                                        <div className="phone-number">{formatPhoneForDisplay(phoneNumber)}</div>
                                                    </div>
                                                    <span id='endCall' onClick={endCallHandler} className='text-center bg-danger cursor-pointer d-block rounded-5 py-2 text-white d-flex justify-content-center align-items-center gap-1 w-40 fw-500'>End Call</span>
                                                    {/* <UncontrolledTooltip placement="top" style={{ minWidth: "100px" }} popperClassName="text-left" innerClassName="text-left" target={`endCall`}>
                                                        {
                                                            <div className='m-0 pl-3 text-left' >
                                                                End Call
                                                            </div>

                                                        }
                                                    </UncontrolledTooltip> */}
                                                </div>
                                                <Card className="chat-box">
                                                    <CardBody className="chat-body">
                                                        <h3 className="chat-header">Call in progress...</h3>
                                                        <div className="chat-messages">
                                                            {messages.map((msg, index) => (
                                                                <div key={index} className={`message-row ${msg.sender === "user" ? "user-message" : "bot-message"}`}>
                                                                    {msg.sender === "bot" && (
                                                                        <div className="bot-icon">
                                                                            <img src={chatAi} alt="AI" className="chat-ai-image" />
                                                                        </div>
                                                                    )}
                                                                    <div className={`message-content ${msg.sender === "user" ? "user-bubble" : "bot-bubble"}`}>
                                                                        {msg.text}
                                                                    </div>
                                                                    {msg.sender === "user" && <div className="user-icon">YOU</div>}
                                                                </div>
                                                            ))}
                                                            <div ref={chatRef}></div>
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="call-summary-container">
                                            <div className="timer-container">
                                                <div className="call-ended">
                                                    <div className="wave-container">
                                                        <img src={waves} alt="Waves" className="wave-image" />
                                                    </div>
                                                    <h3 className="call-ended-text">Call Ended</h3>
                                                </div>
                                            </div>
                                            <div className="summary-container">
                                                <Card className="summary-box">
                                                    <CardBody className="summary-body">
                                                        <h3 className="summary-header">Here's the Summary of your call</h3>
                                                        <div className="summary-text">{callSummary}</div>
                                                    </CardBody>
                                                </Card>
                                                <Link to={"/call-list"} className="d-inline-block font-normal text-center py-2 px-4 rounded fs-16 text-decoration-none text-white linear-gradient-btn w-100">Back to Call List</Link>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}
                        </Col>
                    </Row>
                    <Modal isOpen={callErrorModal} toggle={() => { setCallErrorModal(false) }} centered={true} size='md' keyboard={false}>
                        <ModalBody>
                            <Row>
                                <Col md={12} className='text-center'>
                                    <Image src={warningImg} alt="Event" className='rounded-circle mb-3' height='150px' width='150px' objectFit='cover' />
                                    <h2>Unable to Make Call</h2>
                                    <p>You've reached your trial limit of 10 minutes. Please select a plan to continue calling!</p>
                                </Col>
                            </Row>
                            <Row className="text-center mt-3">
                                <Col>
                                    <Link to={"/pricing-plans"} className="font-normal py-2 px-4 rounded fs-16 text-decoration-none text-white linear-gradient-btn">Select Subscription Plan</Link>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                    <Modal
                        isOpen={dynamicVariableModal}
                        toggle={() => setDynamicVariableModal(false)}
                        centered={true}
                        size="md"
                        keyboard={false}
                    >
                        <ModalHeader toggle={() => setDynamicVariableModal(false)}>
                            Fill Dynamic Variables
                        </ModalHeader>

                        <ModalBody>
                            <Row>
                                {dynamicFields.map((field) => (
                                    <Col md={12} className="mb-3" key={field}>
                                        <Label className="text-left text-black font-bold">
                                            {field}
                                        </Label>
                                        <Input
                                            type="text"
                                            className="custom-input rounded border-0 py-2"
                                            value={dynamicVariableValues[field] || ""}
                                            onChange={(e) => handleDynamicVariableChange(field, e.target.value)}
                                            placeholder={`Enter ${field}`}
                                        />
                                        {dynamicVariableErrors[field] && (
                                            <p className="invalid-feedback">{dynamicVariableErrors[field]}</p>
                                        )}
                                    </Col>
                                ))}
                            </Row>
                        </ModalBody>

                        <ModalFooter>
                            <Button
                                type="button"
                                className="px-4 py-2 rounded btn-danger"
                                onClick={() => setDynamicVariableModal(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                disabled={loading}
                                type="button"
                                className="px-4 py-2 rounded linear-gradient-btn"
                                onClick={handleDynamicVariableSubmit}
                            >
                                {loading ? "Please Wait" : "Continue"}
                            </Button>
                        </ModalFooter>
                    </Modal>
                    <Modal
                        isOpen={otpModal}
                        toggle={() => setOtpModal(false)}
                        centered={true}
                        size="md"
                        keyboard={false}
                    >
                        <ModalHeader toggle={() => setOtpModal(false)}>
                            Verify Your Number
                        </ModalHeader>

                        <ModalBody>
                            <p className="text-muted text-center mb-4">
                                Trial calls require verification. Please enter the OTP sent to{" "}
                                <span className="fw-500">{formatPhoneForDisplay(pendingOtpCallData?.currentPhone)}</span>
                            </p>
                            <div className="d-flex justify-content-center gap-2 mb-3">
                                <OtpInput
                                    value={callOtp}
                                    onChange={(value) => { setCallOtp(value); setOtpError(""); }}
                                    numInputs={6}
                                    shouldAutoFocus={true}
                                    renderSeparator={<span> </span>}
                                    renderInput={(props) => <input {...props} />}
                                    inputStyle={{ width: "60px", height: "60px", borderRadius: "7px", border: "none", backgroundColor: "#f1f1f1", fontSize: "20px" }}
                                    containerStyle={"otp-input"}
                                />
                            </div>
                            {otpError && <div className="invalid-feedback d-block text-center mb-3">{otpError}</div>}
                            <Row>
                                <Col md={12} className="text-center">
                                    {canResendOtp ? (
                                        <Link onClick={handleResendOtp} className="text-gray-200">
                                            Didn't receive the code? Resend OTP
                                        </Link>
                                    ) : (
                                        <span className="text-primary">
                                            Resend OTP in <span className="fw-600">{String(Math.floor(otpTimer / 60)).padStart(2, '0')}:{String(otpTimer % 60).padStart(2, '0')}</span>
                                        </span>
                                    )}
                                </Col>
                            </Row>
                        </ModalBody>

                        <ModalFooter>
                            <Button
                                type="button"
                                className="px-4 py-2 rounded btn-danger"
                                onClick={() => setOtpModal(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                disabled={loading || otpSending}
                                type="button"
                                className="px-4 py-2 rounded linear-gradient-btn"
                                onClick={handleVerifyAndCall}
                            >
                                {loading ? "Please Wait" : "Verify & Call"}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default MakeCall;